// @flow

import updateOrderCaveatField from '../../../Services/updateOrderCaveatField';
import type { UpdateOrderCaveatFieldParams } from '../../../types';

export default (params: UpdateOrderCaveatFieldParams) => async (dispatch: Function) => dispatch(updateOrderCaveatField(params));